import { InputHTMLAttributes, forwardRef } from "react"
import { useCombobox } from "./Root"
import { StyledInput } from "../StyledInput"
import SearchField from "./styles/SearchField"
import { SearchIconLegacy } from "../styles/shared"
import { Variant } from "./types"
import { InputButton } from "./InputButton"

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> {
  onInputValueChange?: (value: string) => void
  variant?: Variant
  dataTestId?: string
}

const Input: React.FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  ({ onInputValueChange, variant, dataTestId, ...inputProps }: InputProps, forwardedRef) => {
    const { state, dispatch } = useCombobox(`Input`)

    const onClear = () => {
      if (!state.selectedItem) return
      onInputValueChange?.(``)
      dispatch({
        type: `setInputValue`,
        value: undefined,
      })
      dispatch({
        type: `selectItem`,
        item: null,
      })
    }

    const toggleOpen = () => {
      dispatch({ type: `setOpen`, open: !state.open })
    }
    return (
      <SearchField disabled={inputProps.disabled}>
        {variant === `search` && <SearchIconLegacy />}

        <StyledInput
          ref={forwardedRef}
          data-testid={dataTestId}
          onFocus={() => dispatch({ type: `setOpen`, open: true })}
          onBlur={() => dispatch({ type: `setOpen`, open: false })}
          value={state.inputValue ?? state.selectedItem ?? ``}
          onChange={(event) => {
            onInputValueChange?.(event.target.value)

            dispatch({
              type: `setInputValue`,
              value: event.target.value,
            })
          }}
          {...inputProps}
        />
        <InputButton
          disabled={inputProps.disabled}
          value={state.inputValue ?? state.selectedItem ?? ``}
          isOpen={state.open}
          variant={variant}
          onClear={onClear}
          toggleOpen={toggleOpen}
        />
      </SearchField>
    )
  }
)

Input.defaultProps = {
  dataTestId: undefined,
  onInputValueChange: undefined,
  variant: undefined,
}

Input.displayName = `ComboboxInput`

export { Input }
